import Button, {
	ButtonColor,
} from 'components/button';
import './deviationItem.scss';

export const DeviationItem = ({
	text,
	show,
}: any) => {
	if (show === undefined) {
		return (
			<div className="deviation-item">
				<div className="deviation-item-text">
					{text}
				</div>
			</div>
		);
	}
	return (
		<Button
			className="deviation-item"
			onClick={() => show(true)}
			color={ButtonColor.WHITE}
		>
			<div className="deviation-item-text">{text}</div>
		</Button>
	);
};